import * as React from 'react';
import classnames from 'classnames';
import { IconYellowArrow } from '../../data/icons';
import { container, hidden as hiddenStyle, arrow } from './DownArrow.module.scss';

function getDocHeight() {
    const body = document.body;
    const html = document.documentElement;
    return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
}

export default () => {
    const [hidden, setHidden] = React.useState(false);
    const handleScroll = event => {
        if (window.pageYOffset + window.innerHeight + 10 >= getDocHeight()) {
            setHidden(true);
            return;
        }

        if (hidden) {
            setHidden(false);
        }
    };
    React.useEffect(() => {
        window.addEventListener('scroll', handleScroll, { passive: true });

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [hidden]);

    const arrowClick = () => {
        const currentScroll = window.pageYOffset;
        const scrollPoints = document.querySelectorAll('[data-scrollpoint]');
        for (let point of scrollPoints) {
            const top = point.getBoundingClientRect().top + currentScroll;
            if (currentScroll + 10 < top) {
                point.scrollIntoView({ behavior: 'smooth', block: 'start' });
                return;
            }
        }
        window.scroll({ top: getDocHeight(), left: 0, behavior: 'smooth' });
    };
    return (
        <div className={classnames(container, { [hiddenStyle]: hidden })}>
            <div className={arrow} onClick={arrowClick}>
                <IconYellowArrow />
            </div>
        </div>
    );
};
